module.exports = __webpack_public_path__ + "img/duplicateFlowIcon.c6ac70d6.svg";